import { Component, OnDestroy, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { SidebarService } from "@core/services/sidebar.service";
import { StorageService } from "@core/services/storage.service";
import { Features } from "@shared/DTO/features";
import { ProductState } from "@shared/DTO/productState";
import { ClientAccountService } from "@shared/services/client-account.service";
import { ConfigurationService } from "@shared/services/configuration.service";
import { FeaturesService } from "@shared/services/features.service";
import { SettingService } from "@shared/services/setting.service";
import { UsersService } from "@shared/services/users.service";
import { Observable, Subscription } from "rxjs";
import { filter, tap } from "rxjs/operators";
import { ExternalLinkItemModel } from "../../models/external-link-item.model";
import { MenuItemModel, MenuSubItemModel } from "../../models/menu-item.model";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit, OnDestroy {
  menuList: MenuItemModel[] = [];
  activeMenu: string;
  routerEvents$: Subscription;
  isSIdebarActive: boolean;
  isAccountChosen: boolean = false;
  featuresUpdate$: Observable<Features>;
  features: Features;

  constructor(
    public clientAccountService: ClientAccountService,
    public router: Router,
    public sidebarService: SidebarService,
    public usersService: UsersService,
    public featuresService: FeaturesService,
    public settingService: SettingService,
    public storageService: StorageService,
    private configurationService: ConfigurationService
  ) {
    this.clientAccountService.onAccountChoice.subscribe((chosen) => {
      this.isAccountChosen = chosen;
      this.menuList = [];
      this.inizializzaMenu();
    });
  }

  ngOnInit(): void {
    // manage page title header
    this.routerEvents$ = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((data) => {
        this.activeMenu = data["url"];
      });

    this.featuresUpdate$ = this.featuresService.onFeaturesUpdate();
  }

  ngOnDestroy(): void {
    this.routerEvents$.unsubscribe();
  }

  handleRefresh(uri) {
    if (uri[0] === "/orders/new-order") {
      this.router
        .navigateByUrl("/", { skipLocationChange: true })
        .then(() => this.router.navigate(uri));
    }
  }

  inizializzaMenu() {
    this.menuList.push(
      new MenuItemModel(
        "Dashboard",
        ["/dashboard"],
        "active",
        null,
        "fas fa-house-user fa-2x",
        null,
        null,
        true
      ),
      new MenuItemModel(
        "SIDEBAR.REQUESTS_TITLE",
        ["orders"],
        "active",
        null,
        "fas fa-box fa-2x",
        [
          new MenuSubItemModel(
            "SIDEBAR.PRODUCTS.NEW",
            ["/orders/new-order"],
            "active",
            null,
            false,
            "fas fa-cart-plus fa-2x"
          ),
          new MenuSubItemModel(
            "SIDEBAR.PRODUCTS.NEW_MASSIVE",
            ["/csv/new-order"],
            "active",
            null,
            false,
            "fas fa-cart-plus fa-2x"
          ),
          new MenuSubItemModel(
            "DRAFTS",
            ["/orders/drafts"],
            "active",
            null,
            false,
            "fas fa-pencil-ruler fa-2x"
          ),
        ],
        false,
        this.isAccountChosen
      ),
      new MenuItemModel(
        "SIDEBAR.PRODUCTS.SEARCH",
        ["search"],
        "active",
        null,
        "fas fa-search-plus fa-2x",
        [
          new MenuSubItemModel(
            "BUTTON.SEARCH",
            ["/search/search-order"],
            "active",
            null,
            false,
            "fas fa-search fa-2x"
          ),
          new MenuSubItemModel(
            "PRODUCT_STATES." + ProductState.BOOKED,
            ["/search/filtered-search", ProductState.BOOKED],
            "active",
            null,
            false,
            "fas fa-ellipsis-h fa-2x"
          ),
          new MenuSubItemModel(
            "PRODUCT_STATES." + ProductState.REGISTERED,
            ["/search/filtered-search", ProductState.REGISTERED],
            "active",
            null,
            false,
            "fas fa-pen-nib fa-2x"
          ),
          new MenuSubItemModel(
            "PRODUCT_STATES." + ProductState.PROCESSED,
            ["/search/filtered-search", ProductState.PROCESSED],
            "active",
            null,
            false,
            "fas fa-spinner fa-2x"
          ),
          new MenuSubItemModel(
            "PRODUCT_STATES." + ProductState.REVOKED,
            ["/search/filtered-search", ProductState.REVOKED],
            "active",
            null,
            false,
            "fas fa-ban fa-2x"
          ),
          new MenuSubItemModel(
            "PRODUCT_STATES." + ProductState.ACTIVE,
            ["/search/filtered-search", ProductState.ACTIVE],
            "active",
            null,
            false,
            "fas fa-plug fa-2x"
          ),
          new MenuSubItemModel(
            "SIDEBAR.SEARCH.MASSIVE",
            ["/search/massive"],
            "active",
            null,
            false,
            "fas fa-house-user fa-2x"
          )
        ],
        false,
        true
      )
    );

    // mock per ora su callcenter (cacata da togliere ovviamente)
    if (this.usersService.isCallCenterUser()) {
      this.menuList = this.menuList.filter(
        (menu) =>
          menu.label !== "SIDEBAR.REQUESTS_TITLE" &&
          menu.label !== "SIDEBAR.PRODUCTS.SEARCH"
      );
      this.menuList.push(
        new MenuItemModel(
          'SIDEBAR.PRODUCTS.SEARCH',
          ['search'],
          'active',
          null,
          'fas fa-search-plus fa-2x',
          [
            new MenuSubItemModel(
              'BUTTON.SEARCH',
              ['/search/search-order'],
              'active',
              null,
              false,
              'fas fa-search fa-2x'
            ),
          ],
          false
        ),
        new MenuItemModel(
          'SIDEBAR.CONFIGURATION',
          ['configuration'],
          'active',
          null,
          'fas fa-cog fa-2x'
        ),
        new MenuItemModel(
          'SIDEBAR.MANAGEMENT',
          ['management'],
          'active',
          null,
          'fas fa-suitcase fa-2x'
        ),
        new ExternalLinkItemModel(
          'REVOKE_SIGN_CERT',
          'fas fa-certificate fa-2x',
          false,
          true,
          this.configurationService.configuration.external.ncar
        ),
      );
    } else {
      this.menuList.push(
        new MenuItemModel(
          'SIDEBAR.CONFIGURATION',
          ['configuration'],
          'active',
          null,
          'fas fa-cog fa-2x'
        ),
        new MenuItemModel(
          'SIDEBAR.MANAGEMENT',
          ['management'],
          'active',
          null,
          'fas fa-suitcase fa-2x'
        ),
        new MenuItemModel(
          'SIDEBAR.CONTRACT_TEMPLATES',
          ['documentation'],
          'active',
          null,
          'fas fa-file fa-2x',
          null,
          false,
          true
        ),
        new ExternalLinkItemModel(
          'REVOKE_SIGN_CERT',
          'fas fa-certificate fa-2x',
          false,
          this.isAccountChosen,
          this.configurationService.configuration.external.ncar
        ),
        new ExternalLinkItemModel(
          'SIDEBAR.LEGALMAIL',
          'fas fa-mail-bulk fa-2x',
          false,
          true,
          this.configurationService.configuration.external.intermediari
        ),
      );
    }
  }
}
